// Endpoints de qualidade — `/v1/metricas/qualidade/*` (MET-18..MET-21).
import { api } from '@/lib/api';
import type { Drilldown, MetricsSurveyDto, Segmented, SurveyKind, WithEnvelope } from '../model';
import {
  metricsUrl,
  type MetricsListArgs,
  type MetricsQueryArgs,
  type MetricsSegmentArgs,
} from './shared';

/** MET-18: CSAT e NPS são o MESMO endpoint com `kind` diferente. */
export interface MetricsSurveyArgs extends MetricsQueryArgs {
  kind: SurveyKind;
}

/** MET-21: drill-down de um assunto. */
export interface MetricsTopicArgs extends MetricsListArgs {
  topicId: string;
}

export const metricsQualityApi = api.injectEndpoints({
  endpoints: (build) => ({
    metricsSurvey: build.query<WithEnvelope<MetricsSurveyDto>, MetricsSurveyArgs>({
      query: (args) => metricsUrl('qualidade/satisfacao', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    metricsSurveyNegatives: build.query<WithEnvelope<Drilldown>, MetricsListArgs>({
      query: (args) => metricsUrl('qualidade/satisfacao/negativas', { ...args }),
      providesTags: ['MetricsDrilldown'],
    }),
    /** MET-19 — reabertura de conversa. */
    metricsReopen: build.query<WithEnvelope<Segmented>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('qualidade/reabertura', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    /** MET-20 — abandono (cliente parou de responder). */
    metricsAbandon: build.query<WithEnvelope<Segmented>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('qualidade/abandono', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    metricsAbandonList: build.query<WithEnvelope<Drilldown>, MetricsListArgs>({
      query: (args) => metricsUrl('qualidade/abandono/lista', { ...args }),
      providesTags: ['MetricsDrilldown'],
    }),
    /** MET-21 — assuntos mais frequentes. */
    metricsTopics: build.query<WithEnvelope<Segmented>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('qualidade/assuntos', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    metricsTopicConversations: build.query<WithEnvelope<Drilldown>, MetricsTopicArgs>({
      query: ({ topicId, ...args }) =>
        metricsUrl(`qualidade/assuntos/${encodeURIComponent(topicId)}/conversas`, { ...args }),
      providesTags: ['MetricsDrilldown'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useMetricsSurveyQuery,
  useMetricsSurveyNegativesQuery,
  useMetricsReopenQuery,
  useMetricsAbandonQuery,
  useMetricsAbandonListQuery,
  useMetricsTopicsQuery,
  useMetricsTopicConversationsQuery,
} = metricsQualityApi;
